import { ApiBase } from '../api-base'

export class VisitServices extends ApiBase {
  constructor() {
    super({
      resource: '/api/v1/visit_invitations',
      name: 'visitInvitation',
      successPath: null
    })
  }

  sendInvitations({ body }) {
    return this.api.post(this.resource, body).then(r => r.data)
  }

  // helper de normalización
  normalizeListPayload(data) {
    return (
      data?.visit_invitations_admin ??
      data?.visit_invitations ??
      data?.items ??
      data ??
      []
    )
  }

  listPending(params = {}) {
    return this.api
      .get(`${this.resource}/pending`, { params })
      .then(r => this.normalizeListPayload(r.data))
  }

  listApprovedActive(params = {}) {
    return this.api
      .get(`${this.resource}/approved_active`, { params })
      .then(r => this.normalizeListPayload(r.data))
  }

  bulkApprove({ group_ids }) {
    return this.api.post(`${this.resource}/bulk_approve`, { group_ids }).then(r => r.data)
  }

  bulkReject({ group_ids }) {
    return this.api.post(`${this.resource}/bulk_reject`, { group_ids }).then(r => r.data)
  }

  approveInvitation(id) {
    return this.api.post(`${this.resource}/${id}/approve`).then(r => r.data)
  }

  rejectInvitation(id) {
    return this.api.post(`${this.resource}/${id}/reject`).then(r => r.data)
  }

  /**
   * Historial paginado
   * params: { page, per_page, q, final_state, date_from, date_to, office_id }
   * devuelve: { items, meta }
   */
  listHistory(params = {}) {
   return this.api
     .get(`${this.resource}/history`, params)      .then(r => {
        const items = this.normalizeListPayload(r.data)
        const meta = r.data?.meta?.pagy || r.data?.meta || { page: 1, pages: 1, count: items.length }
        return { items, meta }
      })
  }
}

export const visitServices = new VisitServices()